<mat-stepper [disableRipple]="true" [selectedIndex]="selectors.currentLookupAccountStep | select" labelPosition="bottom"
             class="px-stepper-locked lg:mx-10">
  <mat-step label="Lookup Account" [completed]="selectors.isComplete('lookupAccount') | select" [editable]="false">
    <px-lookup-account-form/>
  </mat-step>
  <mat-step label="Verify Email" [completed]="selectors.isComplete('verifyEmail') | select" [editable]="false">
    @if (selectors.verificationExpired | select) {
      <px-registration-verify-email-expired/>
    } @else if (selectors.isComplete('enterEmail') | select) {
      <px-registration-verify-email-form/>
    } @else {
      <px-registration-email-form [email]="selectors.email | select:''" [forLookupContext]="true"/>
    }
  </mat-step>
  <mat-step label="Create Password" [completed]="selectors.isComplete('createPassword') | select" [editable]="false">
    <px-registration-create-password-form [forLookupContext]="true"/>
  </mat-step>
  <mat-step label="Complete">
    <px-registration-complete [forLookupContext]="true"/>
  </mat-step>
</mat-stepper>
